export const buttonsConfig = [
  {
    id: 1,
    buttonName: 'Ordinary Drinks',
    endpoint: '/filter.php?c=Ordinary_Drink'
  },
  {
    id: 2,
    buttonName: 'Coctails',
    endpoint: '/filter.php?c=Cocktail'
  },
  {
    id: 3,
    buttonName: 'Non alcoholic',
    endpoint: '/filter.php?a=Non_Alcoholic'
  },
  {
    id: 4,
    buttonName: 'Alcoholic',
    endpoint: '/filter.php?a=Alcoholic'
  },
  {
    id: 5,
    buttonName: 'Shots',
    endpoint: '/filter.php?c=Shot'
  },
  {
    id: 6,
    buttonName: 'Cocoa ',
    endpoint: '/filter.php?c=Cocoa'
  },
  {
    id: 7,
    buttonName: 'Soft Drinks',
    endpoint: '/filter.php?c=Soft_Drink'
  },
  {
    id: 8,
    buttonName: 'Shake Drinks',
    endpoint: '/filter.php?c=Shake'
  },
  {
    id: 9,
    buttonName: 'Beer Drinks',
    endpoint: '/filter.php?c=Beer'
  }
];
